import { stringArrayToObject } from '../../utils/array';

import I18n from '../../config/i18n';

import { actionCreators as toastActions } from '../Toasts/actions';

import { getRolePermissions, updateRolePermissions } from '../../services/RoleService';

export const actions = stringArrayToObject(
  [
    'CLEAR',
    'LOAD_START',
    'LOAD_SUCCESS',
    'LOAD_FAIL',
    'UPDATE_START',
    'UPDATE_SUCCESS',
    'UPDATE_FAIL',
  ],
  '@@ROLE_PERMISSIONS',
);

const privateActionCreators = {
  loadStart() {
    return {
      type: actions.LOAD_START,
    };
  },
  loadSuccess({ admin, editor }) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: { admin, editor },
    };
  },
  loadFail(error) {
    return {
      type: actions.LOAD_FAIL,
      payload: { error },
    };
  },
  updateStart() {
    return {
      type: actions.UPDATE_START,
    };
  },
  updateSuccess() {
    return {
      type: actions.UPDATE_SUCCESS,
    };
  },
  updateFail(error) {
    return {
      type: actions.UPDATE_FAIL,
      payload: { error },
    };
  },
};

export const actionCreators = {
  clear() {
    return {
      type: actions.CLEAR,
    };
  },
  load() {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart());
      const response = await getRolePermissions();
      if (response.ok) {
        dispatch(privateActionCreators.loadSuccess(response.permissions));
      } else {
        dispatch(privateActionCreators.loadFail(response.error));
      }
    };
  },
  update(type, data) {
    return async (dispatch) => {
      dispatch(privateActionCreators.updateStart());
      const response = await updateRolePermissions(type, data);
      if (response.ok) {
        dispatch(privateActionCreators.updateSuccess());
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('forms.updateRoles.messages.success'),
        }));
      } else {
        dispatch(privateActionCreators.updateFail(response.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('forms.updateRoles.errors.fail'),
        }));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/RolePermissions/actions.js